export enum AuthorizationInformationConstants {
  NOT_IMPLEMENTED = 'authorizationInformation/NOT_IMPLEMENTED',
  SET_TRANSPORTAUTHORIZATIONCODE = 'authorizationInformation/SET_TRANSPORTAUTHORIZATIONCODE',
  SET_REASONFORINTERFACILITYTRANSFER = 'authorizationInformation/SET_REASONFORINTERFACILITYTRANSFER',
  SET_REASONFORINTERFACILITYTRANSFER_PNNV = 'authorizationInformation/SET_REASONFORINTERFACILITYTRANSFER_PNNV',
  SET_JUSTIFICATIONFORTRANSFER = 'authorizationInformation/SET_JUSTIFICATIONFORTRANSFER',
  SAVE_AUTHORIZATIONINFO = 'authorizationInformation/SAVE_AUTHORIZATIONINFO',
  RESET_STATE = 'authorizationInformation/RESET_STATE',
  SET_AUTHORIZATION_INFORMATION_STATE = 'authorizationInformation/SET_AUTHORIZATION_INFORMATION_STATE',
}
